import { render, staticRenderFns } from "./LPDataImporter.vue?vue&type=template&id=a86a34d6&"
import script from "./LPDataImporter.vue?vue&type=script&lang=js&"
export * from "./LPDataImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports